/**
 * Trunnion AI - Global Search API Endpoints
 */

import apiClient from './client';
import type { SearchResponse, SearchResult } from '@/types';

const BASE = '/search';

export const searchApi = {
  /**
   * Perform a global search across workflows, agents, executions, and audit events.
   *
   * @param query   - Search query string (minimum 2 characters).
   * @param types   - Optional comma-separated entity types to search (e.g. "workflows,agents").
   * @param limit   - Maximum number of results per entity type (default 20).
   * @returns         Array of unified search results.
   */
  globalSearch: async (
    query: string,
    types?: string,
    limit?: number,
  ): Promise<SearchResult[]> => {
    const params: Record<string, string | number> = { q: query };
    if (types) params.types = types;
    if (limit) params.limit = limit;

    const { data } = await apiClient.get<SearchResponse>(BASE, { params });
    return data.results;
  },
};
